import { render, staticRenderFns } from "./create-creatify.vue?vue&type=template&id=701c966b&"
import script from "./create-creatify.vue?vue&type=script&lang=js&"
export * from "./create-creatify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports